import type { ReactElement, SVGProps } from "react";
import { cn } from "@/lib/utils";

/** Magnifying glass — web search. */
export function WebSearchIcon(props: SVGProps<SVGSVGElement>): ReactElement {
  return (
    <svg
      width={14}
      height={14}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
      className={cn("flex-shrink-0", props.className)}
    >
      <circle cx="11" cy="11" r="8" />
      <path d="m21 21-4.3-4.3" />
    </svg>
  );
}
